var map = {
	"./1/courses/index.json": 2532
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2531;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/students ^\.\/.*\/courses\/index\.json$
// module id = 2531
// module chunks = 0